import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "flag"
const FlagIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.586 12.218C22.688 12.598 22.64 13.035 22.398 13.397 21.394 14.896 19.95 15.4 18.422 15.477 16.953 15.55 15.28 15.234 13.75 15.015 12.162 14.788 10.672 14.653 9.344 14.968 8.135 15.254 7.025 15.923 6.116 17.366L6.98 20.615 7.31 21.855 7.4 22.19 7.43 22.307C7.538 22.707 7.3 23.118 6.9 23.225S6.088 23.093 5.981 22.693L5.951 22.576 5.86 22.24 5.53 21 4.434 16.88C3.57 13.642 2.532 9.743 1.824 7.096 1.672 6.528 1.739 5.882 2.102 5.351 3.256 3.663 4.718 2.841 6.3 2.523 7.839 2.212 9.47 2.383 10.974 2.603 12.528 2.834 13.91 3.106 15.155 3.1 16.367 3.095 17.284 2.82 17.957 2.078 18.263 1.74 18.703 1.636 19.073 1.698 19.45 1.76 19.872 2.024 20.005 2.53 20.856 5.76 21.721 8.989 22.586 12.217M5.624 15.522C6.603 14.42 7.755 13.803 8.998 13.51 10.628 13.122 12.37 13.303 13.962 13.53 15.612 13.766 17.067 14.044 18.346 13.98 19.556 13.917 20.475 13.552 21.133 12.59 20.317 9.544 19.502 6.497 18.697 3.448 17.683 4.333 16.43 4.594 15.162 4.599 13.767 4.607 12.196 4.3 10.756 4.089 9.264 3.868 7.86 3.738 6.596 3.993 5.372 4.24 4.259 4.853 3.34 6.198 3.254 6.323 3.219 6.508 3.273 6.708 3.912 9.096 4.819 12.503 5.624 15.523" />
        </svg>
      }
    </span>
  )
}
export default FlagIcon
